import _ from 'underscore';

import Base, { baseInit } from './base';
import { TargetableElement } from './targetable-element';

class Targeting extends Base {
  static validations = {
    geoTargeting(val) {
      if (_.isEmpty(val)) {
        return new Error('Geo targeting is required');
      }
      return val.isValid();
    },

    audienceTargeting(val) {
      if (_.isEmpty(val)) {
        return null;
      }
      return val.isValid();
    },

    publisherTargeting(val) {
      if (_.isEmpty(val)) {
        return null;
      }
      return val.isValid();
    },
  };

  geoTargeting = null; // TargetableElement{}
  audienceTargeting = null; // TargetableElement{}
  publisherTargeting = null; // TargetableElement{}

  constructor(data) {
    super(data);
    baseInit(this, data);

    if (this.geoTargeting) {
      this.geoTargeting = new TargetableElement(this.geoTargeting);
    }
    if (this.audienceTargeting) {
      this.audienceTargeting = new TargetableElement(this.audienceTargeting);
    }
    if (this.publisherTargeting) {
      this.publisherTargeting = new TargetableElement(this.publisherTargeting);
    }
  }
}

export { Targeting };
